import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import Search from '@material-ui/icons/Search';

//- data
import { post } from '../../modules/utility';
import StationInvoicesContainer from '../../containers/accounting/StationInvoices';
import BulkInvoicesContainer from '../../containers/accounting/BulkInvoices';
import BulkCustomersContainer from '../../containers/logistics/BulkCustomers';
import StationsContainer from '../../containers/Stations';
import CarriersContainer from '../../containers/logistics/Carriers';
import TerminalsContainer from '../../containers/logistics/Terminals';
import AuthUserContainer from '../../containers/AuthUser';

//- ui
import FMPHeadline from '../../components/ui/FMPHeadline';
import FMPSelect from '../../components/pureForm/FMPSelect';
import FMPCheckbox from '../../components/pureForm/FMPCheckbox';
import FMPSectionHeader from '../../components/ui/FMPSectionHeader';
import FMPCarrierMultiSelect from '../../components/pureForm/FMPCarrierMultiSelect';
import FMPTerminalMultiSelect from '../../components/pureForm/FMPTerminalMultiSelect';
import FMPText from '../../components/pureForm/FMPText';

import { invoiceStatusClassNames } from '../accounting/general';
import invoiceIcon from '../../images/invoicePdf.svg';
import quickbooksLogo from '../../images/quickbooksLogo.svg';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormComponent from '../../components/FormComponent';
import EnhancedTable from '../../components/table/EnhancedTable';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import SearchIcon from '@material-ui/icons/Search';
import Popover from '@material-ui/core/Popover';

import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Slide from '@material-ui/core/Slide';
import { green } from '@material-ui/core/colors';
import orange from '@material-ui/core/colors/orange';
import { getSharedStyles } from '../../themes';
import FMPMonthYearPicker from '../../components/pureForm/FMPMonthYearPicker';
import { formatStationCogs, formatBulkCogs } from './profitReportUtil';
import WarningIcon from '@material-ui/icons/Warning';

import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';

import Typography from '@material-ui/core/Typography';
import { showErrors } from '../../modules/general';

function TabContainer({ children, dir }) {
	return (
		<Typography component="div" dir={dir} style={{ padding: 8 * 2 }}>
			{children}
		</Typography>
	);
}
TabContainer.propTypes = {
	children: PropTypes.node.isRequired,
	dir: PropTypes.string.isRequired,
};

const SlideUpTransition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const isLocalhost = Boolean(window.location.hostname === 'localhost');

const stationColumns = [
	{
		sortId: 'status',
		displayId: 'statusDisplay',
		label: 'Status',
	},
	{
		sortId: 'deliveryDateSort',
		displayId: 'deliveryDisplay',
		label: 'Delivery Info',
	},
	{
		sortId: 'railcarSort',
		displayId: 'railcarDisplay',
		label: 'Railcar Info',
	},
	{
		sortId: 'deliveryDateSort2',
		displayId: 'invoiceDisplay',
		label: 'Invoice / Rack Transfer Info',
	},
	{
		sortId: 'deliveryDateSort3',
		displayId: 'vendorBillDisplay',
		label: 'Vendor Bill Info',
	},
	{
		sortId: 'freightDemurrageTotalCost',
		displayId: 'demurrageDisplay',
		label: 'Demurrage Cost',
	},
	{
		sortId: 'cogsPerGallon',
		displayId: 'cogsDisplay',
		label: 'Freight Cost',
	},
];

const styles = (theme) => {
	return {
		...invoiceStatusClassNames,
		...getSharedStyles(theme),
		bigButton: {
			borderRadius: '100px',
			padding: '18px 34px',
			fontSize: 16,
		},
		smallButton: {
			borderRadius: '100px',
			fontWeight: 200,
		},
		pickPlease: {
			background: '#F7F7F7',
			border: '1px solid #DDDDDD',
			padding: 20,
			color: '#666',
		},
		divider: {
			borderBottom: '1px dashed #dddddd',
			marginBottom: 25,
			marginTop: 25,
		},
		stats: {
			padding: '20px 10px 20px 10px',
			borderBottom: '1px solid #ddd',
			marginBottom: 10,
		},
		statGroup: {
			padding: '5px 5px 10px 5px',
			borderBottom: '1px solid #eee',
			marginBottom: 10,
		},
		available: {
			fontWeight: 900,
		},
		invoiceDocument: {
			position: 'absolute',
		},
		invoiceDocumentContainer: {
			position: 'relative',
			display: 'flex',
			alignItems: 'center',
		},
		invoiceIcon: {
			display: 'inline-block',
			width: 40,
			height: 48,
			backgroundImage: `url('${invoiceIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor: 'pointer',
		},
		quickbooksIcon: {
			display: 'inline-block',
			width: 40,
			height: 40,
			backgroundImage: `url('${quickbooksLogo}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor: 'pointer',
		},
		table: {
			width: '100%',
			tableLayout: 'auto',
		},
		row: {
			cursor: 'pointer',
		},
		button: {
			verticalAlign: 'middle',
			padding: '8px 10px',
		},
		resultsHere: {
			padding: 30,
			backgroundColor: '#f1f1f1',
			color: '#777',
			borderRadius: 10,
		},
		runningSearch: {
			paddingLeft: 5,
			display: 'flex',
			alignItems: 'center',
			fontSize: 16,
			color: '#666',
		},
		dateRange: {
			marginRight: 10,
		},
		icon: {
			marginRight: 5,
		},
		linkedItem: {
			fontSize: 14,
			textDecoration: 'none',
			display: 'flex',
			alignItems: 'center',
		},
		openLink: {
			paddingLeft: 4,
			width: 14,
			height: 14,
		},
		diffError: {
			fontWeight: 900,
			color: '#FF500F',
		},
		contractSub: {
			paddingLeft: 10,
			fontSize: 14,
			color: '#666',
		},
		todo: {
			border: `1px solid #bbb`,
			color: '#666',
			padding: 5,
			fontStyle: 'italic',
		},
		addButton: {
			verticalAlign: 'middle',
			textDecoration: 'none',
			marginBottom: 10,
			borderRadius: 100,
		},
		fuelGroup: {
			marginBottom: 7,
		},
		savedSearchHelp: {
			padding: 10,
			color: '#444',
			backgroundColor: '#f7f7f7',
			border: '1px solid #eee',
			marginTop: 5,
			fontWeight: 200,
			marginBottom: 10,
		},
		saveNewSearchSection: {
			//borderTop : '1px solid #d7d7d7',
			marginTop: 20,
			paddingTop: 10,
		},
		noSavedSearches: {
			color: '#666',
			padding: 5,
			fontStyle: 'italic',
		},
		savedSearchContainer: {
			marginTop: 10,
			paddingTop: 10,
			borderBottom: '1px solid #d7d7d7',
			marginBottom: 10,
			paddingBottom: 5,
			display: 'flex',
			justifyContent: 'space-between',
		},
		addedOn: {
			fontSize: '85%',
			fontWeight: 200,
			color: '#666',
			paddingTop: 3,
		},
		snackbarSuccess: {
			backgroundColor: green[600],
		},
		snackbarIcon: {
			opacity: 0.9,
			marginRight: theme.spacing(1),
			fontSize: 20,
		},
		snackbarMessage: {
			display: 'flex',
			alignItems: 'center',
		},
		cancelled: {
			color: orange[500],
			fontWeight: 900,
		},
		popOverPaper: {
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 20,
		},
		commentsContainer: {
			padding: 7,
			display: 'inline-block',
			fontSize: '95%',
		},
		commentDateTime: {
			fontSize: '80%',
			color: '#666',
		},
		popover: {
			pointerEvents: 'none',
		},
		terminalSupplier: {
			borderLeft: '2px solid #ccc',
			paddingLeft: 5,
			marginBottom: 7,
		},
		warningIcon: {
			color: '#FFC107',
			width: 16,
			height: 16,
			paddingRight: 5,
			borderRight: '1px solid #f1f1f1',
			verticalAlign: 'middle',
		},
	};
};

class FreightProfitSearch extends FormComponent {
	constructor(props) {
		super(props);

		let savedSearches = [];
		if (localStorage.getItem('freightSaveSearches')) {
			try {
				savedSearches = JSON.parse(localStorage.getItem('freightSaveSearches'));
			} catch (e) {
				console.error('problems fetching saved searches from local storage', e);
			}
		}

		const dateRange = 'lastMonth';
		const { yearMonth } = this.dateRangeToDates(dateRange);
		this.state = {
			savedSearches,
			formFieldError: {},
			deliveryType: 'station',
			dateRange,
			yearMonth,
			searchResultRows: undefined,
			isSearching: false,
			includeTankTransfers: false,

			order: 'desc',
			orderBy: 'stationInvoiceId',
			carrierIds: [],
			pickupTerminalIds: [],
			deliveryTerminalIds: [],
			commentPopoverAnchor: undefined,
			popoverComment: '',
		};
	}

	componentDidMount() {
		//- Only used for updates
		const {
			bulkCustomers,
			searchBulkCustomers,
			stations,
			searchStations,
			terminals,
			searchTerminals,
			carriers,
			searchCarriers,
		} = this.props;

		if (_.isEmpty(bulkCustomers)) {
			searchBulkCustomers();
		}
		if (_.isEmpty(stations)) {
			searchStations();
		}
		if (_.isEmpty(carriers)) {
			searchCarriers();
		}
		if (_.isEmpty(terminals)) {
			searchTerminals();
		}
	}

	getApiParams = () => {
		const { accessToken } = this.props;

		const { yearMonth, deliveryType, onlyGmStations, includeTankTransfers } = this.state;
		const yearMonthMoment = yearMonth ? moment(yearMonth, 'YYYY-MM') : moment();
		const isInvoice = deliveryType === 'stationInvoice' || deliveryType === 'bulkInvoice';

		const params = {
			accessToken,
			month: yearMonthMoment.month(),
			year: yearMonthMoment.year(),
			deliveryType,
			onlyGmStations,
			includeTankTransfers,
		};

		if (isInvoice) {
			params.invoiceType = deliveryType === 'stationInvoice' ? 'station' : 'bulk';
		} else {
			params.deliveryType = deliveryType;
		}

		['stationIds', 'bulkCustomerIds', 'carrierIds', 'pickupTerminalIds'].forEach((s) => {
			if (this.state[s]) {
				params[`${s}`] = this.state[s];
			}
		});
		return params;
	};

	submitSearch = () => {
		const { showErrors } = this.props;
		const { deliveryType } = this.state;

		if (deliveryType) {
			this.submitDeliverySearch();
		} else {
			showErrors(['Select a delivery or invoice type']);
		}
	};

	submitDeliverySearch = () => {
		const { showErrors } = this.props;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		this.setState({
			isSearching: true,
		});

		const { deliveryType } = this.state;
		const isInvoice = deliveryType === 'stationInvoice' || deliveryType === 'bulkInvoice';

		const params = this.getApiParams();
		post({
			method: isInvoice ? 'freightProfitReport.byInvoice.search' : 'freightProfitReport.search',
			params,
			callback: (err, apiSearchResult) => {
				this.setState({ isSearching: false });
				if (err) {
					return showErrors(_.isArray(err) ? err : [err]);
				}

				if (deliveryType === 'bulk' || deliveryType === 'bulkInvoice') {
					const { cogs, errors } = this.formatBulkCogs({
						apiSearchResult,
						isFreight: true,
					});

					this.setState({
						deliveryErrors: errors,
						deliveryBulkCogs: cogs,
						isSearching: false,
					});
				} else {
					const { cogs, errors } = this.formatStationCogs({
						apiSearchResult,
						isFreight: true,
					});

					this.setState({
						deliveryErrors: errors,
						deliveryStationCogs: cogs,
						isSearching: false,
					});
				}
			},
		});
	};

	handleSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({ snackbarIsOpen: false });
	};

	handleCommentPopoverOpen = (event, internalNote) => {
		this.setState({
			popoverComment: internalNote,
			commentPopoverAnchor: event.currentTarget,
		});
	};
	handleCommentPopoverClose = () => {
		this.setState({ commentPopoverAnchor: null });
	};

	formatStationCogs = formatStationCogs.bind(this);
	formatBulkCogs = formatBulkCogs.bind(this);

	render() {
		const { classes } = this.props;
		return (
			<Grid container spacing={2}>
				<Grid item md={8} xs={12}>
					{this.renderSearch()}
				</Grid>
				<Grid item md={4} xs={12}>
					{this.renderSaveSearches()}
				</Grid>
				<Grid item md={12} xs={12}>
					{this.renderResults()}
				</Grid>

				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'right',
					}}
					open={this.state.snackbarIsOpen}
					autoHideDuration={2000}
					onClose={this.handleSnackbarClose}
					TransitionComponent={SlideUpTransition}
				>
					<SnackbarContent
						className={classes.snackbarSuccess}
						ariaDescribeBby="client-snackbar"
						message={
							<span id="client-snackbar" className={classes.snackbarMessage}>
								<CheckCircleIcon className={classes.snackbarIcon} />
								<strong>{this.state.snackbarMessage} </strong>
							</span>
						}
						action={[
							<IconButton
								key="close"
								aria-label="close"
								color="inherit"
								onClick={this.handleSnackbarClose}
							>
								<CloseIcon className={classes.icon} />
							</IconButton>,
						]}
					/>
				</Snackbar>

				<Popover
					id="comment-popover"
					className={classes.popover}
					classes={{ paper: classes.popOverPaper }}
					open={!!this.state.commentPopoverAnchor}
					anchorEl={this.state.commentPopoverAnchor}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
					onClose={this.state.handleCommentPopoverClose}
					disableRestoreFocus
				>
					<div className={classes.commentsContainer}>
						{!!this.state.popoverComment && <div>{this.state.popoverComment}</div>}
					</div>
				</Popover>
			</Grid>
		);
	}

	saveSearch() {
		const {
			savedSearches,
			savedName,
			deliveryType,
			carrierIds,
			pickupTerminalIds,
			deliveryTerminalIds,
			dateRange,
		} = this.state;

		const { showErrors } = this.props;

		const formFieldError = {};

		if (!savedName) {
			formFieldError.savedName = `Do you like chaos?! If you don't name your search then you get chaos.`;
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		const newSavedSearches = savedSearches.concat({
			name: savedName,
			dateCreated: moment().format('YYYY-MM-DD HH:mm'),
			savedState: {
				deliveryType,
				carrierIds,
				pickupTerminalIds,
				deliveryTerminalIds,
				dateRange,
			},
		});
		this.setState({ savedSearches: newSavedSearches }, () => {
			localStorage.setItem('freightSaveSearches', JSON.stringify(newSavedSearches));
		});

		//items to save
	}

	removeSavedSearch(index) {
		const { savedSearches } = this.state;
		const newSavedSearches = savedSearches.slice();
		newSavedSearches.splice(index, 1);
		this.setState({ savedSearches: newSavedSearches }, () => {
			localStorage.setItem('freightDeliverySaveSearches', JSON.stringify(newSavedSearches));
		});
	}

	runSavedSearch(index) {
		const { savedSearches } = this.state;
		const savedSearch = savedSearches[index];
		if (!savedSearch) {
			console.error('Saved search empty', savedSearches);
			return;
		}

		const { savedState } = savedSearch;
		if (savedState.dateRange) {
			const { yearMonth } = this.dateRangeToDates(savedState.dateRange);
			if (yearMonth) {
				savedState.yearMonth = yearMonth;
			}
		}

		this.setState(savedState, () => {
			this.submitSearch();
		});
	}

	renderSaveSearches() {
		const { classes } = this.props;
		const { savedSearches } = this.state;
		return (
			<>
				<FMPHeadline label="My Saved Searches" />
				<Paper className={classes.paper}>
					<FMPSectionHeader label="My Saved Searches" isTop={true} />
					<div className={classes.savedSearchHelp}>
						<strong>How to use:</strong> First set the values for all the search fields you want to
						save on the left. Then pick a name for your saved search and hit add. This saved search
						will be available on future visits.
					</div>
					{_.isEmpty(savedSearches) && (
						<div className={classes.noSavedSearches}>No saved searches</div>
					)}

					{savedSearches.map((savedSearch, index) => {
						const { name, dateCreated } = savedSearch;
						return (
							<div className={classes.savedSearchContainer} key={name}>
								<div>
									<div>
										<strong>Name:</strong> {name}
									</div>
									<div className={classes.addedOn}>
										Date Created: {moment(dateCreated).format('MMM D, YYYY')}
									</div>
								</div>
								<div>
									<IconButton
										color="primary"
										onClick={() => {
											this.runSavedSearch(index);
										}}
									>
										<SearchIcon />
									</IconButton>

									<IconButton
										onClick={() => {
											this.removeSavedSearch(index);
										}}
									>
										<DeleteIcon />
									</IconButton>
								</div>
							</div>
						);
					})}

					<div className={classes.saveNewSearchSection}>
						<FMPText {...this.setForm('savedName', 'Name of saved search', false)} />
						<Button
							variant={'outlined'}
							color="primary"
							style={{ marginTop: 5 }}
							onClick={() => {
								this.saveSearch();
							}}
						>
							Save Search
						</Button>
					</div>
				</Paper>
			</>
		);
	}

	renderSearch() {
		const { classes } = this.props;
		const { stationFormatErrors, deliveryType } = this.state;
		const isBulk = deliveryType === 'bulk' || deliveryType === 'bulkInvoice';

		return (
			<>
				<FMPHeadline label="Freight Report Search" />
				<Paper className={classes.paper}>
					<Grid container spacing={2}>
						<FMPSelect
							{...this.setForm('deliveryType', 'Search By')}
							options={[
								{ value: 'station', display: 'Station Deliveries' },
								{ value: 'bulk', display: 'Bulk Deliveries' },
								{ value: 'stationInvoice', display: 'Station Invoices' },
								{ value: 'bulkInvoice', display: 'Bulk Invoices' },
							]}
						/>

						{isBulk && (
							<FMPCheckbox
								{...this.setForm(
									'includeTankTransfers',
									'Include Tank Transfers (Bulk Customer RTC Fuels)',
									false,
									false
								)}
							/>
						)}
					</Grid>

					<Grid container spacing={2}>
						<div className={classes.divider} />
						{this.renderAllSearchOptions()}
						{this.renderSubmitButtons()}
					</Grid>
				</Paper>

				{!_.isEmpty(stationFormatErrors) && this.renderErrors(stationFormatErrors)}
			</>
		);
	}

	renderResults() {
		const { classes } = this.props;
		const { deliveryType, deliveryBulkCogs, deliveryStationCogs, deliveryErrors } = this.state;

		//const rows = deliveryType === 'bulk' ? formattedBulkDeliveryCogs : formattedStationDeliveryCogs;
		const deliveryRows = deliveryType === 'bulk' ? deliveryBulkCogs : deliveryStationCogs;

		let rows;
		let columns;
		let formatErrors;
		if (!_.isEmpty(deliveryRows)) {
			columns = stationColumns;
			rows = deliveryRows;
			formatErrors = deliveryErrors;
		}

		return (
			<>
				{!_.isEmpty(formatErrors) && this.renderErrors(formatErrors)}
				<Paper className={classes.paper} style={{ marginTop: 20 }}>
					{_.isEmpty(rows) && <div className={classes.resultsHere}>Results here</div>}
					{!_.isEmpty(rows) && (
						<EnhancedTable
							isDense={true}
							columns={columns}
							rows={rows}
							defaultOrder={'asc'}
							defaultOrderBy={'deliveryDateSort'}
						/>
					)}
				</Paper>
			</>
		);
	}

	renderErrors = (errors) => {
		const { classes } = this.props;
		return (
			<ExpansionPanel className={classes.paper} style={{ marginTop: 15, paddingBottom: 10 }}>
				<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} style={{ padding: 0 }}>
					<div style={{ paddingBottom: 10, fontSize: '120%' }}>
						<WarningIcon className={classes.warningIcon} />
						<strong>Analysis Errors ({errors.length})</strong>
					</div>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails style={{ display: 'block' }}>
					{errors.map((error, i) => {
						return (
							<div key={i} style={{ padding: 5 }}>
								{error}
							</div>
						);
					})}
				</ExpansionPanelDetails>
			</ExpansionPanel>
		);
	};

	setDateRange = (dateRange) => {
		const { yearMonth } = this.dateRangeToDates(dateRange);
		if (!yearMonth) {
			this.setState({ dateRange });
		} else {
			this.setState({ dateRange, yearMonth });
		}
	};

	dateRangeToDates = (dateRange) => {
		if (dateRange === 'thisMonth') {
			return {
				yearMonth: moment().startOf('month').format('YYYY-MM'),
			};
		} else if (dateRange === 'lastMonth') {
			return {
				yearMonth: moment().subtract(1, 'month').startOf('month').format('YYYY-MM'),
			};
		} else {
			return {};
		}
	};

	renderDateButton = (label, range) => {
		const { classes } = this.props;
		const { dateRange } = this.state;

		const variant = dateRange === range ? 'contained' : 'outlined';

		return (
			<Button
				className={classes.dateRange}
				variant={variant}
				color="primary"
				onClick={() => {
					this.setDateRange(range);
				}}
			>
				{label}
			</Button>
		);
	};
	renderDateRangeOptions = () => {
		const { dateRange } = this.state;
		let disabled = true;
		if (dateRange === 'custom') {
			disabled = false;
		}

		return (
			<>
				<Grid item md={12}>
					<FMPSectionHeader label={'Date Range'} />
				</Grid>

				<Grid item md={12} style={{ display: 'flex' }}>
					{this.renderDateButton('Current Month', 'thisMonth')}
					{this.renderDateButton('Last Month', 'lastMonth')}
					{this.renderDateButton('Custom', 'custom')}
				</Grid>

				<FMPMonthYearPicker {...this.setForm('yearMonth')} disabled={disabled} />
			</>
		);
	};

	renderSubmitButtons = () => {
		const { classes } = this.props;
		const { isSearching, deliveryType } = this.state;

		const isInvoice = deliveryType === 'stationInvoice' || deliveryType === 'bulkInvoice';

		const params = this.getApiParams();
		params.downloadCsv = true;
		const request = {
			method: isInvoice ? 'freightProfitReport.byInvoice.search' : 'freightProfitReport.search',
			params,
		};

		const host = isLocalhost ? 'http://localhost:3700' : '';
		const downloadUrl = `${host}/api?request=${JSON.stringify(request)}`;

		if (!deliveryType) {
			return showErrors(['Select a delivery']);
		}

		return (
			<Grid container spacing={2}>
				<Grid item md={12} style={{ paddingTop: 25, display: 'flex' }}>
					<Button
						className={classes.bigButton}
						variant="contained"
						color="primary"
						onClick={this.submitSearch}
						disabled={isSearching}
					>
						<Search className={classes.icon} />
						Freight Search
					</Button>

					<a
						href={downloadUrl}
						style={{ textDecoration: 'none', paddingRight: 5 }}
						target="_blank"
						rel="noreferrer noopener"
					>
						<Button
							className={classes.bigButton}
							variant="contained"
							color="primary"
							style={{ marginLeft: 10 }}
						>
							<DownloadIcon className={classes.icon} />
							Search & Download
						</Button>
					</a>

					{isSearching && (
						<div className={classes.runningSearch}>
							<CircularProgress />
							<span style={{ paddingLeft: 5 }}>Searching...</span>
						</div>
					)}
				</Grid>
			</Grid>
		);
	};

	renderAllSearchOptions = () => {
		const { carriers, terminals } = this.props;

		return (
			<>
				{this.renderDateRangeOptions()}

				<FMPCarrierMultiSelect
					{...this.setForm('carrierIds', 'Carriers', false, [])}
					carriers={carriers}
				/>

				<FMPTerminalMultiSelect
					{...this.setForm('pickupTerminalIds', 'Pickup Terminals', false, [])}
					terminals={terminals}
					productTypes={['e85', 'etoh', 'unl']}
				/>
			</>
		);
	};
}

FreightProfitSearch.propTypes = {
	classes: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
	history: PropTypes.object,
	canMakeUpdates: PropTypes.bool,

	bulkCustomers: PropTypes.array,
	searchBulkCustomers: PropTypes.func.isRequired,

	stations: PropTypes.array,
	searchStations: PropTypes.func.isRequired,

	carriers: PropTypes.array,
	searchCarriers: PropTypes.func.isRequired,

	terminals: PropTypes.array,
	searchTerminals: PropTypes.func.isRequired,

	accessToken: PropTypes.sring,

	stationMap: PropTypes.object,
	carrierMap: PropTypes.object,
	invoiceDocumentMap: PropTypes.object,
	stationDeliveryMap: PropTypes.object,
	terminalMap: PropTypes.object,
	supplierMap: PropTypes.object,
	bulkCustomerMap: PropTypes.object,
	bulkDeliveryMap: PropTypes.object,
	resourceMap: PropTypes.object,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	StationInvoicesContainer,
	BulkInvoicesContainer,
	BulkCustomersContainer,
	StationsContainer,
	CarriersContainer,
	TerminalsContainer,
	AuthUserContainer,
])(FreightProfitSearch);
